import React from 'react'
import styled from 'styled-components'

const ProgramBox = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  min-width: 166px;
  border-radius: 8px;
  margin: 5px !important;
  background-color: ${props => props.selected ? '#00d1b2' : 'white'};
  border: ${props => props.selected ? 'none' : '1px solid lightgrey'};
  transition: all 0.2s;
  color: ${props => props.selected ? 'white' : 'lightgrey'};
  
  &:hover {
    transform: scale(1.01);
    box-shadow: 0 0 4px 0 rgba(0, 58, 155, 0.5);
  }
  
  &:active {
    box-shadow: 0 0 0 0 rgba(0, 58, 155, 0.5);
  } 
`

const Programs = (props) => {
  const {
    handleNextClick,
    handleBackClick,
    handleChange,
    programIndex,
    locationData } = props
  const programs = locationData.programs
  const isDisabled = programIndex === null

  return (
    <section className="section animated slideInLeft">
      <div className="columns">
        <div className="column is-half is-offset-one-quarter">
          <h1 className="title has-text-primary">
            For...
          </h1>
          <div className="tile is-ancestor">
            <div className="tile is-parent" style={{flexWrap: 'wrap', alignItems: 'center'}}>
              { programs.map((program, i) => {
                return (
                  <ProgramBox selected={programIndex === i} key={i} className="tile is-2-desktop hero-body" onClick={() => handleChange(program, i)}>
                    <div>{program.name}</div>
                  </ProgramBox>
                )
              })}
            </div>
          </div>
          <div className="field is-grouped" style={{marginTop: 10}}>
            <p className="control">
              <a className="button is-outline is-medium" onClick={() => handleBackClick()}>
                Back
              </a>
            </p>
            <p className="control">
              <button disabled={isDisabled} className="button is-primary is-medium" onClick={() => handleNextClick()}>
                Next
              </button>
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Programs


// WEBPACK FOOTER //
// ./src/views/Programs.js